import { AnalyticsApi, AnalyticsEvent, DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

const FLUSH_MS = 30_000;

/** Cuenta las páginas visitadas y las manda al backend `usage` cada 30 s (y al cerrar la pestaña). Sin terceros. */
export class UsageAnalytics implements AnalyticsApi {
  private paths: string[] = [];

  constructor(private readonly discovery: DiscoveryApi, private readonly fetchApi: FetchApi) {
    setInterval(() => this.flush(), FLUSH_MS);
    window.addEventListener('pagehide', () => this.flush());
  }

  captureEvent(event: AnalyticsEvent) {
    if (event.action === 'navigate') this.paths.push(event.subject);
  }

  private async flush() {
    if (!this.paths.length) return;
    const paths = this.paths.splice(0);
    try {
      const base = await this.discovery.getBaseUrl('usage');
      await this.fetchApi.fetch(`${base}/events`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ paths }),
        keepalive: true,
      });
    } catch {
      // Medir el uso nunca debe romper la navegación.
    }
  }
}
